import { createSlice } from '@reduxjs/toolkit';

// Initial state for the customer
export const initialState = {
  customerId: 0,
  avatar: '',
  userName: '',
  email: '',
  type: [],
  token: '',
  venderSearch: '', 
  shippingCargesByCountry:{
    subTotal: 0,
    deliveryCharges: 0
  },
  country: "Kuwait"
};

export const customerSlice = createSlice({
  name: 'customerAuth',
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      return { ...state, ...action.payload }; 
    },
    customerLoggedOut: () => initialState,
    setVendeSearch: (state, action) => {
      state.venderSearch = action.payload; // Update venderSearch immutably
    },
    setShippingCargesByCountry: (state, action) => {
			
			state.shippingCargesByCountry = action.payload
		},
    setCountry: (state, action) => {
      state.country = action.payload
    },
  },
});

export const { setCountry, setCustomer, customerLoggedOut, setVendeSearch,setShippingCargesByCountry } =
  customerSlice.actions;

export default customerSlice.reducer;
